export type MaterialCatalogStandard = 'ekonomiczny' | 'standard' | 'premium';

export interface MaterialCatalogItem {
  id: string;
  name: string;
  category: 'paint' | 'primer' | 'plaster';
  standard: MaterialCatalogStandard;
  unit: 'l' | 'kg';
  unitPrice: number;
  source: 'cennik lokalny / użytkownika';
  updatedAt: string;
}

const UPDATED_AT = '2026-06-21';

export const MATERIAL_CATALOG: MaterialCatalogItem[] = [
  {
    id: 'paint_economy_l',
    name: 'Farba akrylowa ekonomiczna',
    category: 'paint',
    standard: 'ekonomiczny',
    unit: 'l',
    unitPrice: 24,
    source: 'cennik lokalny / użytkownika',
    updatedAt: UPDATED_AT,
  },
  {
    id: 'paint_standard_l',
    name: 'Farba lateksowa standard',
    category: 'paint',
    standard: 'standard',
    unit: 'l',
    unitPrice: 35,
    source: 'cennik lokalny / użytkownika',
    updatedAt: UPDATED_AT,
  },
  {
    id: 'paint_premium_l',
    name: 'Farba premium / zmywalna',
    category: 'paint',
    standard: 'premium',
    unit: 'l',
    unitPrice: 58,
    source: 'cennik lokalny / użytkownika',
    updatedAt: UPDATED_AT,
  },
  {
    id: 'primer_standard_l',
    name: 'Grunt standard',
    category: 'primer',
    standard: 'standard',
    unit: 'l',
    unitPrice: 12,
    source: 'cennik lokalny / użytkownika',
    updatedAt: UPDATED_AT,
  },
  {
    id: 'plaster_standard_kg',
    name: 'Gładź szpachlowa standard',
    category: 'plaster',
    standard: 'standard',
    unit: 'kg',
    unitPrice: 2.2,
    source: 'cennik lokalny / użytkownika',
    updatedAt: UPDATED_AT,
  },
];

